import { useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';

ChartJS.register(ArcElement, Tooltip);

type DoughnutWithLegendProps = {
  labels: string[];
  datasets: { data: number[]; backgroundColor: string[] }[];
};

export default function DoughnutWithLegend({
  data,
}: {
  data: DoughnutWithLegendProps;
}) {
  const chartRef = useRef<ChartJS<'doughnut'> | null>(null);

  const toggleSegment = (index: number) => {
    const chart = chartRef.current;
    if (!chart) return;

    chart.toggleDataVisibility(index);
    chart.update();
  };

  return (
    <div style={{ display: 'flex', gap: 30 }}>
      <div style={{ width: 300 }}>
        <Doughnut
          ref={chartRef}
          data={data}
          options={{
            plugins: {
              datalabels: {
                display: false,
              },
              legend: {
                display: false,
              },
            },
          }}
        />
      </div>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {data.labels.map((label, i) => (
          <li
            key={label}
            onClick={() => toggleSegment(i)}
            style={{
              cursor: 'pointer',
              marginBottom: 10,
              display: 'flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <span
              style={{
                width: 14,
                height: 14,
                background: data.datasets[0].backgroundColor[i],
                display: 'inline-block',
              }}
            />
            {label} : {data.datasets[0].data[i]}
          </li>
        ))}
      </ul>
    </div>
  );
}
